import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import '../../styles/common/modal.css';

const ApplicationTimeModal = ({ isOpen, onClose, startDate, endDate }) => {
  const navigate = useNavigate();
  
  // 모달이 열리면 페이지 스크롤 방지
  useEffect(() => {
    if (isOpen) {
      // 모달이 열리면 배경 스크롤 방지
      document.body.style.overflow = 'hidden';
      
      // 컴포넌트 언마운트 시 원래대로 복원
      return () => {
        document.body.style.overflow = 'auto';
      };
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleConfirm = () => {
    onClose();
    navigate('/');
  };

  return (
    <div 
      className="modal-overlay"
      style={{ 
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999
      }}
    >
      <div 
        className="modal-content"
        style={{
          backgroundColor: '#fff',
          padding: '30px',
          borderRadius: '8px',
          maxWidth: '500px',
          width: '90%',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
        }}
      >
        <h2>Application Period Notice</h2>
        <p>
          It is not yet the application period.
          Applications will be accepted from {startDate} - {endDate} 15:00 KST.
        </p>
        <div className="modal-buttons">
          <button 
            className="modal-button save" 
            onClick={handleConfirm}
            style={{
              backgroundColor: '#2563eb',
              color: 'white',
              border: 'none',
              padding: '10px 16px',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

ApplicationTimeModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired
};

export default ApplicationTimeModal;